import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";

const state = {
  programRegistrationFields: [],
  registrationFieldsLoaded: false,
  createTeamAfterSignIn: false,
  createTeamFormData: {}
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
};
